export enum CarouselNavPositionEnum {
  LEFT = 'left',
  RIGHT = 'right',
}
